/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Shared query_id values for analytics viewedScreen events.
 */
export const VIEWED_SCREEN_QUERY_IDS = {
  ENTER: "enter",
  EXIT: "exit",
  EMPTY: ""
} as const;

export type ViewedScreenQueryId =
  (typeof VIEWED_SCREEN_QUERY_IDS)[keyof typeof VIEWED_SCREEN_QUERY_IDS];
